import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { AccountProfileDetails } from './AccountProfileDetails'
import { PasswordChange } from './PasswordChange';
import { AccountLogout } from './AccountLogout';
import CustomAlert from '../../components/CustomAlert';

const title = "User Details"

export const AccountSettings = (props) => {
    const [showAlert, setShowAlert] = React.useState(false);
    const [message, setMessage] = React.useState("")
    const [severity, setSeverity] = React.useState("success");

    return (
        <>
        <CustomAlert showAlert={showAlert} message={message} severity={severity} setShowAlert={setShowAlert} setMessage={setMessage}/>
        <Box component="div" sx={{
            height: "calc(100vh - 160px)",
            width: "100%",
            overflow: "auto",
            padding: 2
        }}>
            <Typography variant="h5" component="h1" sx={{ mb: 2 }}>
                Account Settings
            </Typography>

            <Grid
                container
                spacing={2}
            >
                <Grid
                    item
                    md={12}
                    xs={12}
                > <AccountProfileDetails title={title} {...props} setMessage={setMessage} setSeverity={setSeverity} /></Grid>
                <Grid
                    item
                    md={12}
                    xs={12}
                ><PasswordChange setMessage={setMessage} setSeverity={setSeverity} /> </Grid>
                <Grid
                    item
                    md={12}
                    xs={12}
                ><AccountLogout/> </Grid>
            </Grid>
        </Box>
        </>
    );
}

